import React, { useContext, useEffect, useState } from 'react'
import Layout from '../Layouts/Layout';
import TopSection from '../Common/TopSection';
import { InventoryContext } from '../Context/InventoryContext';
import DataTable, { createTheme } from 'react-data-table-component';

const Export = ({ onExport }) => <div className="d-none d-lg-block"><button onClick={e => onExport(e.target.value)} className="blue-btn" type="button"><span className=""></span>Export</button></div>;    

const InventoryImages = ({}) => {
    const [data,setData] = useState({});
    const { getInventoryImages, inventoryImages, uploadDocument, addInventoryImage, deleteInventoryImages, publishVehicle } = useContext(InventoryContext);

    const queryParameters = new URLSearchParams(window.location.search)
    const show_published = queryParameters.get("show_published");

    useEffect(() => {
        getInventoryImages(show_published);
    },[]);

    useEffect(() => {
        setData(inventoryImages);        
    }, [inventoryImages]);

    createTheme('solarized', {
        text: {
          primary: '#ffffff',
          secondary: '#ffffff',
        },
        background: {
          default: '#353a40',
        },
        context: {
          background: '#cb4b16',
          text: '#FFFFFF',
        },
        divider: {
          default: '#757575',
        },
        action: {
          button: 'rgba(0,0,0,.54)',
          hover: 'rgba(0,0,0,.08)',
          disabled: 'rgba(0,0,0,.12)',
        },
      }, 'dark');
    
    const columns = [
        {
            name: 'Vehicle',
            selector: row => row.vehicle_name,
            sortable: true,
            width: "250px"
        },
        {
            name: 'VIN',
            selector: row => row.vin,
            sortable: true,
            width: "200px"
        },
        {
            name: 'Link',
            cell:(row) => <a onClick={() => {window.open(row.details_url, "_blank", "noreferrer")}} id={row.ID}>VDP Link</a>,
            grow: 0
        },
        {
            name: 'Photos',
            cell:(row) => <a onClick={() => {downloadPhotos(row.images)}} id={row.ID}>{row.image_count} photos</a>,
            grow: 0
        },
        {
            name: 'Uploaded Photos',
            cell:(row) => <a onClick={() => {downloadPhotos(row.images)}} id={row.ID}>{row.uploaded_image_count} photos</a>,
            grow: 0
        },
        {
            name: 'Upload',
            selector: row => row.vin,
            cell:(row) => <input
                type="file"
                id="photo-upload"
                multiple
                onChange={(event) => handleImageChange(event,row.vin)}
            />
        },
        {
            name: 'Delete Images',
            cell:(row) => <button onClick={() => {deleteImages(row.vin)}} id={row.ID}>Delete Images</button>,
            width: "150px"
        },
        {
            name: 'Publish',
            selector: row => row.vin,
            cell:(row) => <button onClick={() => {publishVIN(row.vin)}} id={row.ID}>Publish</button>,
            grow: 0
        },
        {
            name: 'Publish Scraped Images',
            selector: row => row.vin,
            cell:(row) => <button onClick={() => {publishVIN(row.vin,row.image_urls)}} id={row.ID}>Publish Scraped Photos</button>
        },
    ];

    const downloadPhotos = (images) => {
        images.map((v,i) => {
            window.open(v);
        });        
    }

    const deleteImages = async (vin) => {
        const response = await deleteInventoryImages(vin);

        alert(response.success ? "Images deleted" : "There was a problem");
    }

    const publishVIN = async (vin,image_urls) => {
        const response = await publishVehicle(vin,image_urls);

        console.log(response);

        alert(response.success ? "Vehicle Published" : "There was a problem");
    }

    const uploadFile = (file,vin) => {
        console.log(file);

        if (file) {

            console.log(file);

            const formData = new FormData();
            formData.append('file', file);
            formData.append('folder', 'inventoryimages/' + vin + '/');
            formData.append('fileName',file.name);
            //formData.append('base_url',true);

            const upload = uploadDocument(formData);
            upload.then((data) => {
                if (data.url && data.data && data.data.key) {

                    console.log(data);

                    addInventoryImage(vin,data.data.key);
                    
                } else if(data.error) alert(data.error);
            });
        }
            
    }

    const handleImageChange = (event,vin) => {
        const files = Array.from(event.target.files);
        //setFieldValue('photos', event.target.files);

        Array.from(files).map((v,i) => {
            uploadFile(v,vin);
        });
    };

    function exportTableToCSV(array) {

    
        // Temporary delimiter characters unlikely to be typed by keyboard
        // This is to avoid accidentally splitting the actual contents
        const tmpColDelim = String.fromCharCode(11); // vertical tab character
        const tmpRowDelim = String.fromCharCode(0); // null character
        const keys = Object.keys(array[0]);

        // actual delimiter characters for CSV format
        const colDelim = '","';
        const rowDelim = '"\r\n"';

        array.unshift(keys);
    
          // Grab text from table into CSV formatted string
        var csv = '"' + array.map(function(row,i) { 
            return Object.values(row).map(function(col,j) { 
                return (col + "").replace(/"/g, '""'); // escape double quotes    
            }).join(tmpColDelim);
    
        }).join(tmpRowDelim)
        .split(tmpRowDelim).join(rowDelim)
        .split(tmpColDelim).join(colDelim) + '"';
    
        return csv;
      }

    function downloadCSV(array) {
        const link = document.createElement('a');
        let csv = exportTableToCSV(array);
        if (csv == null) return;

        const filename = 'export.csv';

        var csvData = 'data:application/csv;charset=utf-8,' + encodeURIComponent(csv);

        link.setAttribute('href', csvData);
        link.setAttribute('download', filename);
        link.click();
    }   

    const actionsMemo = React.useMemo(() => <Export onExport={() => downloadCSV(data)} />, []);

    return (
        <>
            <Layout>
            <TopSection/>
                <div className='main-block'>
                    <div className='container-fluid'>
                    
                    {data && <DataTable title="Invnetory Images" columns={columns} data={data} actions={actionsMemo} theme="solarized" />};

                    </div>
                </div>
            </Layout>
        </>
    )
}

export default InventoryImages;